/*
 * Copyright 2022, TeamDev. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Redistribution and use in source and/or binary forms, with or without
 * modification, must retain the above copyright notice and the following
 * disclaimer.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _googleProtobuf = require("google-protobuf");

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _typeParsers = _interopRequireDefault(require("./parser/type-parsers"));

var _knownTypes = _interopRequireDefault(require("./known-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * A utility which converts the JS object to its Protobuf counterpart.
 */
var ObjectToProto = /*#__PURE__*/function () {
  function ObjectToProto() {
    _classCallCheck(this, ObjectToProto);

    throw new Error('ObjectToProto is not supposed to be instantiated.');
  }
  /**
   * Converts the object to the corresponding Protobuf message.
   *
   * The input object is supposed to be a Protobuf message representation, i.e. all of its attributes should
   * correspond to the fields of the specified message type.
   *
   * @param {!Object} object an object to convert
   * @param {!string} typeUrl a type URL of the corresponding Protobuf message
   */


  _createClass(ObjectToProto, null, [{
    key: "convert",
    value: function convert(object, typeUrl) {
      if (!_knownTypes["default"].hasType(typeUrl)) {
        throw new Error("Unable to convert object of unknown type ".concat(typeUrl));
      }

      var parser = _typeParsers["default"].parserFor(typeUrl);

      var proto = parser.fromObject(object);
      return proto;
    }
    /**
     * Convert the given observable of objects to the observable of the
     * corresponding Protobuf messages.
     *
     * @param {!Observable<Object>} observable an observable to convert
     * @param {!string} typeUrl a type URL of the corresponding Protobuf message
     * @return {Observable<Message>} an observable of converted Protobuf messages
     */

  }, {
    key: "map",
    value: function map(observable, typeUrl) {
      return observable.pipe((0, _operators.map)(function (object) {
        return ObjectToProto.convert(object, typeUrl);
      }));
    }
  }]);

  return ObjectToProto;
}();

exports["default"] = ObjectToProto;
//# sourceMappingURL=object-to-proto.js.map